module.exports = __webpack_public_path__ + "static/img/cash.ba99f4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/innerMessage/cash.jpg
// module id = ep1p
// module chunks = 0